<div [formGroup]="editForm" class="k-form" *ngIf="loaded">
    <button kendoButton [primary]="true" (click)="addChannel()" type="button" class="mb-2" *ngIf="!isDeleted">
        {{'ADD-CHANNEL' | translate}}<i class="far fa-plus"></i>
    </button>
    <div formGroupName="channels" class="container-channels">
        <table class="table mb-0">
            <thead>
                <tr>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'CHANNEL' | translate
                            }}
                            *
                        </label>
                    </th>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'PRIORITY' | translate
                            }}
                            *
                        </label>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr style="position:relative;top:10px" *ngIf=" editForm.controls.channels.controls.length === 0">
                    {{'NO-RULES-SUMMARY' | translate}}
                </tr>
                <tr *ngFor="let channel of editForm.controls.channels.controls; let i=index; trackBy:channelsTrackBy;">
                    <td style="width:55%" [formGroupName]="i">
                        <kendo-combobox id="channel" class="w-100" formControlName="channel" [valuePrimitive]="false"
                            [itemDisabled]="itemDisabled" [data]="groupedChannels" [textField]="'name'"
                            [valueField]="'id'">
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.channels.controls[i].controls.channel.hasError('required') && 
                                editForm.controls.channels.controls[i].controls.channel.touched">
                            {{ 'REQUIRED-CHANNEL' | translate }}
                        </div>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.channels.controls[i].controls.importError.value">
                            {{ 'ASSESSMENT-DATA-PARTIALLY-LOADED-HINT' | translate }}
                        </div>
                        <!--Add a mt-5 if no score to not overlap the Score is required message-->
                        <div [ngClass]="{'mt-5': editForm.controls.channels.controls[i].controls.priority.hasError('required') && 
                                                 editForm.controls.channels.controls[i].controls.priority.touched}"
                            class="mt-2">
                            <app-formly-designer-rule-edit [ruleIndex]="i" [fields]="fields" [isDeleted]="isDeleted"
                                [expandWidth]="'188%'"
                                [showRules]="editForm.controls.channels.controls[i].controls.showRules.value"
                                [query]="editForm.controls.channels.controls[i].controls.query.value"
                                (showRulesChanged)="showRulesChanged($event)">
                            </app-formly-designer-rule-edit>
                        </div>
                    </td>
                    <td style="width:40%" [formGroupName]="i">
                        <kendo-combobox class="w-50" formControlName="priority" required [data]="priorities"
                            [textField]="'priorityName'" [valueField]="'priority'">
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.channels.controls[i].controls.priority.hasError('required') && editForm.controls.channels.controls[i].controls.priority.touched">
                            {{ 'PRIORITY-REQUIRED' | translate }}
                        </div>
                    </td>
                    <td class="ng-untouched" *ngIf="!isDeleted">
                        <a title="{{ 'DELETE' | translate }}" (click)="removeChannel(i)">
                            <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>